import DiscussMariaAbout from "components/About/DiscussMariaAbout";
import SocialMedia from "components/About/SocialMedia";
import Address from "components/Contact/Address";
import ContactForm from "components/Contact/FormContact";
import HeroContact from "components/Contact/HeroContact";
import TwoContactPath from "components/Contact/TwoContactPath";
import LatestWorkshop from "components/Homepage/LatestWorkshop";
import React from "react";

const Contact = () => {
  return (
    <div>
      <HeroContact />
      <TwoContactPath />
      {/* <ContactForm /> */}
      <Address />
      <DiscussMariaAbout />
      <SocialMedia />
    </div>
  );
};

export default Contact;
